// =====================================================================
// PropertyDetailTable.jsx — Monthly P&L table for /operational/:location.
// Extracted from PropertyDetail.jsx (iter-35e split).
// =====================================================================

const HEADERS = ["Month", "Beds", "Sold", "Occ %", "ADR", "RevPAB", "Bed Rev", "F&B", "Total Rev", "Expense", "EBITDA"];

function occTone(pct) {
  if (pct >= 70) return "text-emerald-600";
  if (pct >= 55) return "text-orange-600";
  return "text-red-600";
}

export default function PropertyDetailTable({ months, activeFY }) {
  return (
    <div className="bg-white border border-brand-line" data-testid="month-table">
      <div className="px-6 py-4 border-b border-brand-line">
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-zinc-500">Month-wise P&L · {activeFY}</div>
        <h3 className="font-display font-bold text-lg mt-1">Detailed breakdown</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-paper">
            <tr className="text-left">
              {HEADERS.map((h) => (
                <th key={h} className="px-4 py-3 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-line">
            {months.map((m) => (
              <tr key={m.key} className="hover:bg-brand-paper" data-testid={`row-${m.key}`}>
                <td className="px-4 py-2.5 font-display font-semibold text-brand-ink">{m.month_label}</td>
                <td className="px-4 py-2.5 font-mono-tech">{m.capacity_beds}</td>
                <td className="px-4 py-2.5 font-mono-tech">{m.sold_beds}</td>
                <td className={`px-4 py-2.5 font-mono-tech font-bold ${occTone(m.occupancy_pct)}`}>{m.occupancy_pct}%</td>
                <td className="px-4 py-2.5 font-mono-tech">₹{m.adr}</td>
                <td className="px-4 py-2.5 font-mono-tech">₹{m.revpab}</td>
                <td className="px-4 py-2.5 font-mono-tech">₹{(m.bed_revenue / 100000).toFixed(1)}L</td>
                <td className="px-4 py-2.5 font-mono-tech">₹{(m.fb_revenue / 100000).toFixed(1)}L</td>
                <td className="px-4 py-2.5 font-mono-tech font-bold">₹{(m.total_revenue / 100000).toFixed(1)}L</td>
                <td className="px-4 py-2.5 font-mono-tech text-red-600">₹{(m.total_expense / 100000).toFixed(1)}L</td>
                <td className={`px-4 py-2.5 font-mono-tech font-bold ${m.ebitda >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                  ₹{(m.ebitda / 100000).toFixed(1)}L
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
